
import ViewOrder from "components/main/ViewOrder";
import ViewBag from "../../components/main/ViewBag";



const ViewOrderPage = () => {
    return <ViewOrder />;
};

export default ViewOrderPage;
